import script from "./ViewEditProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEditProfile.vue?vue&type=script&setup=true&lang=js"

import "./ViewEditProfile.vue?vue&type=style&index=0&id=dd753276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd753276"]])

export default __exports__